// import React from "react";
// import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

// const DeleteModal = ({ deleteTerm, toggle, isOpen, handleDelete }) => {
//   return (
//     <Modal isOpen={isOpen} toggle={toggle}>
//       <ModalHeader>Do you want to delete {deleteTerm}?</ModalHeader>
//       <ModalBody>
//         <span>P.S: Once you delete changes, they cannot be undone.</span>
//       </ModalBody>
//       <ModalFooter>
//         <Button
//           color="danger"
//           onClick={() => {
//             handleDelete();
//             toggle();
//           }}
//         >
//           Delete
//         </Button>
//         <Button className="ms-2" onClick={toggle}>
//           Cancel
//         </Button>
//       </ModalFooter>
//     </Modal>
//   );
// };

// export default DeleteModal;

// import React from "react";
// import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

// const DeleteModal = ({ isOpen, toggle, handleDelete, itemId }) => {
//   const handleConfirm = () => {
//     toggle(); // Close the modal after confirming
//     handleDelete(itemId);
//   };
//   return (
//     <Modal isOpen={isOpen} toggle={toggle}>
//       <ModalHeader toggle={toggle}>Confirm Cancellation</ModalHeader>
//       <ModalBody>Are you sure you want to cancel this appointment?</ModalBody>
//       <ModalFooter>
//         <Button color="secondary" onClick={toggle}>
//           Cancel
//         </Button>
//         <Button color="danger" onClick={handleConfirm}>
//           Confirm
//         </Button>
//       </ModalFooter>
//     </Modal>
//   );
// };

// export default DeleteModal;

import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const DeleteModal = ({
  isOpen,
  toggle,
  handleAction,
  itemId,
  modalTitle = "Confirm Action",
  modalMessage = "Are you sure?",
  confirmButtonText = "Confirm",
}) => {
  const handleConfirm = () => {
    toggle(); // Close the modal after confirming
    handleAction(itemId); // Perform the passed action (e.g., cancel, confirm)
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{modalTitle}</ModalHeader>
      <ModalBody>{modalMessage}</ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <Button color="danger" onClick={handleConfirm}>
          {confirmButtonText}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteModal;
